<app-student-module [PrintOptions]="printOptions" ModuleName="Intervention Logs">
  <div class="d-print d-print-none">
    <table class="table table-striped">
      <thead>
      <tr>
        <th>Date Notified</th>
        <th>Intervention</th>
        <th>Tier</th>
        <th>Start</th>
        <th>End</th>
        <th>
          <button-new btnClass="btn-sm" (btnClick)="new()"></button-new>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of intvlogs">
        <td>{{i.date | date: 'shortDate'}}</td>
        <td>{{i.intervention}}</td>
        <td>{{i.tier}}</td>
        <td>{{ i.start | date: 'shortDate' | blankDate}}</td>
        <td>{{ (i.end || '') | date: 'shortDate' | blankDate}}</td>
        <td>
          <button-more btnClass="btn-sm" (btnClick)="open(i)"></button-more>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="d-none d-print-block">

    <div *ngFor="let log of intvlogs">
      <hr />
      <div class="row">
        <div class="col-6 fw-bold">Date Notified</div>
        <div class="col">{{log.date | date: 'shortDate'}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Implementer</div>
        <div class="col">{{log.implementer | staffId | async}}{{log.legacy}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Intervention</div>
        <div class="col">{{log.intervention}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Tier</div>
        <div class="col">{{log.tier}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Start</div>
        <div class="col">{{log.start | date: 'shortDate' | blankDate}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">End</div>
        <div class="col">{{log.end | date: 'shortDate' | blankDate}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Performance</div>
        <div class="col">{{log.performance}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Days Per Week</div>
        <div class="col">{{log.days_per_week}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Minutes Per Day</div>
        <div class="col">{{log.min_per_day}}</div>
      </div>
      <div class="row">
        <div class="col-6 fw-bold">Other</div>
        <div class="col">{{log.other}}</div>
      </div>
    </div>
  </div>
</app-student-module>

